// plugins/measure/measureToolFactory.ts
import type { Dispatch, UnknownAction } from "@reduxjs/toolkit";
import { createCesiumMeasure } from "./helpers/cesium";
import { createLeafletMeasure } from "./helpers/leaflet";
import { createMapLibreMeasure } from "./helpers/maplibre";
import { createOLMeasure } from "./helpers/openlayers";
import type { MeasureMode, MeasureSegment } from "./types";

export function createMeasureTool(
  mapIntance: any,
  mapType: string,
  mode: MeasureMode,
  segments: MeasureSegment[],
  dispatch: Dispatch<UnknownAction> | any,
) {
  if (mapType === "openlayers") {
    return createOLMeasure(mapIntance, mode);
  }

  if (mapType === "leaflet") {
    return createLeafletMeasure(mapIntance, mode);
  }

  if (mapType === "maplibre") {
    return createMapLibreMeasure(mapIntance, mode, segments, dispatch);
  }

  if (mapType === "cesium") {
    return createCesiumMeasure(mapIntance, mode);
  }

  throw new Error("Unsupported engine");
}
